import { useClient } from 'modules/settings/providers/ClientProvider';
import { useRouter } from 'next/router';
import * as Icons from 'ui/Icons';
import SalesRepButtonNavigation from 'ui/SalesRepButtonNavigation';

import { getSalesRepNav } from './getSalesrepNav';
import { FooterNav, FooterNavButtons } from './styles';

const SalesRepFooter = () => {
  const { client } = useClient();
  const router = useRouter();
  const salesRepNav = getSalesRepNav(client);

  return (
    <FooterNav>
      <FooterNavButtons data-testid="navButtons">
        {salesRepNav.map((link, i) => {
          const isActive =
            router.pathname.includes(link.hrefLink) ||
            (link.hrefLink == '/salesrep/offerings' &&
              router.pathname.includes('/salesrep/offering'));
          return (
            <SalesRepButtonNavigation
              key={i}
              hrefLink={link.hrefLink}
              Icon={Icons[link.Icon]}
              LinkTitle={link.LinkTitle}
              active={isActive}
            />
          );
        })}
      </FooterNavButtons>
    </FooterNav>
  );
};

export default SalesRepFooter;
